export default __webpack_public_path__ + "static/media/breaking-bad.9a92c885.png";